import { lazy } from "react";
import { MODULE_IDS } from "../../constants/enums";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { app_navbar_routes } from "../../constants/app-navbar-routes";

const GateEntryTable = Loadable(
  lazy(() =>
    import("./GateEntryTable").then(({ GateEntryTable }) => ({
      default: GateEntryTable,
    })),
  ),
);

const ManageSingleGateEntry = Loadable(
  lazy(() =>
    import("./ManageSingleGateEntry").then(({ ManageSingleGateEntry }) => ({
      default: ManageSingleGateEntry,
    })),
  ),
);

export const gateEntryRoutes = [
  {
    path: app_navbar_routes.app.grn.gate_entry,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.GRN]}>
        <GateEntryTable />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${app_navbar_routes.app.grn.gate_entry}/manage`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.GRN]}>
        <ManageSingleGateEntry />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${app_navbar_routes.app.grn.gate_entry}/manage/:uuid`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.GRN]}>
        <ManageSingleGateEntry />
      </AuthorizedRoute>
    ),
  },
];
